import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';

import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.page_type - The page type where the event is triggered
 * @param {string} payload.event_category - The event category for the recommendation list click
 */
export const onTrackRecommendListClick = async ({
  page_type,
  event_category,
}) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.RecommendListClick,
    data: { page_type, event_category },
  });
};
